'use strict';

/**
 * List item for the recent export list
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/export-recent-list-item.hbs');

var ExportRecentListItem = ColidoItemView.extend({
    template: template,

    wrapItem: false,

    ui: {
        'deleteItem': '[data-action="delete-item"]',
    },

    events: {
        'click @ui.deleteItem': 'deleteItemAction',
    },

    modelEvents: {
        'change sync': 'render',
    },

    deleteItemAction: function(){
        this.destroy()
    },
});

module.exports = ExportRecentListItem;